import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category?type=movie" },
  { label: "电视剧", to: "/category?type=tv" },
  { label: "资讯", to: "/news" },
  { label: "专题", to: "/special" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname, location.search]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) {
      navigate("/category");
      return;
    }
    navigate(`/category?q=${encodeURIComponent(q)}`);
    setKeyword("");
  };

  const isActive = (to: string) => {
    const path = to.split("?")[0];
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-primary-900 border-b border-primary-800">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center h-16 gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-flight-takeoff-line text-lg" aria-hidden="true"></i>
            </span>
            <span className="text-background-50 font-heading font-bold text-lg tracking-wide whitespace-nowrap">
              诱人的飞行
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-4">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive(item.to)
                    ? "bg-primary-800 text-accent-400"
                    : "text-background-200 hover:bg-primary-800 hover:text-background-50"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <form
            onSubmit={handleSearch}
            className="hidden md:flex items-center ml-auto bg-primary-800 rounded-full px-3 h-10 w-64 lg:w-72 border border-primary-700 focus-within:border-accent-500 transition-colors"
          >
            <i className="ri-search-line text-background-300 text-base" aria-hidden="true"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视名称"
              className="bg-transparent border-none outline-none text-sm text-background-50 placeholder:text-background-400 px-2 w-full"
              aria-label="搜索影视名称"
            />
          </form>

          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md text-background-50 hover:bg-primary-800 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-primary-800 bg-primary-900 px-4 pb-4 animate-fade-in">
          <form onSubmit={handleSearch} className="flex items-center bg-primary-800 rounded-full px-3 h-11 my-3 border border-primary-700">
            <i className="ri-search-line text-background-300 text-base" aria-hidden="true"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视名称"
              className="bg-transparent border-none outline-none text-sm text-background-50 placeholder:text-background-400 px-2 w-full"
              aria-label="搜索影视名称"
            />
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3 py-3 rounded-md text-sm font-medium ${
                  isActive(item.to) ? "bg-primary-800 text-accent-400" : "text-background-200"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}